import { render, staticRenderFns } from "./FighterThumbnail.vue?vue&type=template&id=54ae22dd&scoped=true"
import script from "./FighterThumbnail.vue?vue&type=script&lang=js"
export * from "./FighterThumbnail.vue?vue&type=script&lang=js"
import style0 from "./FighterThumbnail.vue?vue&type=style&index=0&id=54ae22dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ae22dd",
  null
  
)

export default component.exports